import React from 'react'
import styles from '../styles.css'

type PropsType = {
  entry: any
  colors: any
  executeAction: (entry: any, cmdPressed: boolean) => void
}

export const SearchPreview = (props: PropsType) => {
  const { preview, data, name } = props.entry
  const executeAction = props.executeAction

  return (
    <div
      style={{
        width: '40%',
        backgroundColor: props.colors?.secondary
          ? props.colors.secondary
          : '#f4f4f4',
        borderTopLeftRadius: '16px',
        borderBottomRightRadius: '8px'
      }}
    >
      <div
        style={{
          border:
            'solid 10px ' +
            (props.colors?.secondary ? props.colors.secondary : '#f4f4f4'),
          backgroundColor: props.colors?.primary
            ? props.colors.primary
            : 'white',
          padding: '16px',
          textAlign: 'left',
          borderRadius: '8px'
        }}
      >
        {preview && preview.image && (
          <img
            src={preview.image}
            style={{
              width: '100%',
              height: '124px',
              objectFit: 'cover',
              borderRadius: '4px'
            }}
          />
        )}

        <b
          style={{
            fontSize: '12px',
            marginTop: '8px',
            color: props.colors?.text ? props.colors.text : '#333'
          }}
        >
          {name}
        </b>
        <p
          style={{
            fontSize: '12px',
            marginTop: '4px',
            color: props.colors?.text ? props.colors.text : '#333'
          }}
        >
          {data}
        </p>

        <button
          onClick={() => executeAction(props.entry, false)}
          className={styles.previewButton}
        >
          Continue →
        </button>
      </div>
    </div>
  )
}
